import React from 'react';

const Pagination = ({ currentPage, totalPages, totalItems, startIdx, pageSize, onPageChange }) => {
  if (totalPages <= 1) return null;
  
  return (
    <div className="px-4 sm:px-6 py-4 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="text-sm text-gray-500">
        Showing {startIdx + 1} to {Math.min(startIdx + pageSize, totalItems)} of {totalItems} results
      </div>
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className={`px-3 py-1 border rounded-md text-sm ${
            currentPage === 1 
              ? 'text-gray-400 border-gray-200 cursor-not-allowed' 
              : 'text-gray-700 hover:bg-gray-50 border-gray-300'
          }`}
        >
          Previous
        </button>
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          let pageNum;
          if (totalPages <= 5) {
            pageNum = i + 1;
          } else if (currentPage <= 3) {
            pageNum = i + 1;
          } else if (currentPage >= totalPages - 2) {
            pageNum = totalPages - 4 + i;
          } else {
            pageNum = currentPage - 2 + i;
          }
          return (
            <button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={`px-3 py-1 border rounded-md text-sm ${
                currentPage === pageNum 
                  ? 'bg-gray-900 text-white border-gray-900' 
                  : 'text-gray-700 hover:bg-gray-50 border-gray-300'
              }`}
            >
              {pageNum}
            </button>
          );
        })}
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 border rounded-md text-sm ${
            currentPage === totalPages 
              ? 'text-gray-400 border-gray-200 cursor-not-allowed' 
              : 'text-gray-700 hover:bg-gray-50 border-gray-300'
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;

